<h3 mat-dialog-title>EAM Work Request</h3>

<div mat-dialog-content>
    @if (!viewOnly) {
        <div *ngIf="isLoading">
            <h3>Loading Asset Names from Oracle EAM...</h3>
        </div>
        <form *ngIf="!isLoading" [formGroup]="workRequestFormGroup">
            <mat-form-field class="eam-card-dialog">
                <mat-label> Work Request Asset</mat-label>
                <mat-select formControlName="childAsset" id="childAsset" panelWidth="">
                    @for (option of childAssetOptions; track option.CHILD_ASSET) {
                    <mat-option
                        [value]="option.CHILD_ASSET"
                        [disabled]="option.MAINTAINABLE_FLAG === 'N'"
                        [ngStyle]="{'color': option.MAINTAINABLE_FLAG === 'N' ? 'red' : 'black'}">
                        {{ option.CHILD_ASSET }}
                        @if ((isScreen$ | async)?.matches) {
                            <span>&nbsp;&nbsp;&nbsp;&nbsp;({{ option.INSTANCE_DESCRIPTION }})</span>
                        }
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field class="eam-card-dialog">      
                <mat-label>Work Request Priority</mat-label>
                <mat-select formControlName="workPriority" class="form-control" id="workPriority" name="workPriority">
                @for (priority of workPriorityOptions; track priority.value) {
                    <mat-option [value]="priority.value">{{priority.viewValue}}</mat-option>
                }
                </mat-select>
            </mat-form-field> 

            <mat-form-field class="card-dialog">
                <textarea  #descInput matInput cdkTextareaAutosize formControlName="description" [maxlength]="eAMCharacterCount"></textarea>
                <mat-hint align="end">{{ descInput.value.length }} / {{ eAMCharacterCount }}</mat-hint>
            </mat-form-field> 
    
        </form>
    } @else {
            <div><b>Work Request Number</b></div>
            <div >{{problemData.WorkRequestNumber}}</div>
            <div *ngIf="problemData.WorkOrderNumber != 'None'">
                <div><b>Work Order Number</b></div>
                <div>{{problemData.WorkOrderNumber}}</div>
            </div>
            <div><b>Description</b></div>
            <div> 
                {{problemData.Description}} 
            </div>
            <div ><b>Priority</b></div>
            <div >{{problemData.Priority}}</div>
            <div ><b>ASSET NUMBER</b></div>
            <div >{{problemData.AssetNumber}}</div>
    }

</div>

<div mat-dialog-actions class="action-buttons">
  <button mat-raised-button color="primary" *ngIf="!viewOnly" [disabled]="!workRequestFormGroup.dirty || !workRequestFormGroup.valid" (click)="createWorkRequest()" style="padding: 5px;">Create Work Request</button>
  <button mat-raised-button color="primary" (click)="viewWorkRequest()" style="padding: 5px;">View Open Work Requests/Orders</button>
  <button mat-raised-button color="primary" (click)="onNoClick()" style="padding: 5px;">Cancel</button>
</div>